import React, { useState } from 'react'
import { Components } from '@kyndio/kynd-shared-components'
import { Message } from 'semantic-ui-react'
import * as constants from 'kynd_constants'
import * as clientTheme from 'theme'
import axios from 'axios'
import EmailInput from './EmailInput'

import {
  SubmitContainer,
  SubmitButton,
  ModalButtonsContainer,
  StyledForm,
  EmailsContainer,
  InviteMessage,
  BackLink,
  ModalContent,
  FieldWrapper,
} from './styles'

const FormStep2 = (props) => {
  const {
    intl,
    loading,
    disabled,
    status,
    mode,
    modalVisibility,
    domain,
    recipients,
    representative,
    recipientsToAdd,
    setExerciseState,
    endpoint,
    orgName } = props

  const [formErrorMessage, setFormErrorMessage] = useState(intl.formatMessage({ id: 'phishing_tool_form_error' }))
  const [formError, setFormError] = useState(false)

  const onBackToExercise = () => setExerciseState((prevState) => ({ ...prevState, mode: constants.MODE.DEFAULT }))
  const toggleAddMoreRecipientsMode = () => {
    setExerciseState((prevState) => ({ ...prevState, mode: prevState.mode === constants.MODE.DEFAULT ? constants.MODE.ADD_MORE : constants.MODE.DEFAULT }))
  }

  const toggleModalVisibility = () => {
    setExerciseState((prevState) => ({ ...prevState, modalVisibility: !prevState.modalVisibility }))
  }

  const openAddRecipients = () => {
    setFormError(false)
    const recipientsToAdd = []

    recipients.map((item) => {
      if (item.error) {
        setFormErrorMessage(intl.formatMessage({ id: 'phishing_tool_form_error_invalid_values' } ))
        setFormError(true)

        return
      }

      if (item.username) {
        recipientsToAdd.push(`${item.username.trim()}@${representative.domain}`)
      }
    })

    setExerciseState((prevState) => ({ ...prevState, modalVisibility: recipientsToAdd.length > 0, recipientsToAdd }))
  }

  const onMainAction = async () => {
    switch (status) {
      case constants.STATUS.ACCEPTED: {
        openAddRecipients()
        break
      }
      case constants.STATUS.PAUSED: {
        setExerciseState((prevState) => ({ ...prevState, mode: constants.MODE.RESUME, modalVisibility: true }))
        break
      }
      case constants.STATUS.CANCELLED:
      case constants.STATUS.COMPLETED: {
        setExerciseState((prevState) => ({ ...prevState, loading: true, modalVisibility: false }))
        await setStatus(status)
        setExerciseState((prevState) => ({ ...prevState, loading: false, mode: constants.MODE.DEFAULT }))
        break
      }
      default: {
        if (mode === constants.MODE.ADD_MORE) {
          openAddRecipients()
        } else if (mode === constants.MODE.PAUSE_CANCEL) {
          setExerciseState((prevState) => ({ ...prevState, mode: constants.MODE.PAUSE, modalVisibility: true }))
        } else {
          toggleAddMoreRecipientsMode()
        }
        break
      }
    }
  }

  const onSecondaryAction = () => {
    switch (status) {
      case constants.STATUS.ACCEPTED: {
        window.location.reload()
        break
      }
      case constants.STATUS.PAUSED: {
        setExerciseState((prevState) => ({ ...prevState, mode: constants.MODE.CANCEL, modalVisibility: true }))
        break
      }
      default: {
        if (mode === constants.MODE.ADD_MORE) {
          toggleAddMoreRecipientsMode()
        } else if (mode === constants.MODE.PAUSE_CANCEL) {
          setExerciseState((prevState) => ({ ...prevState, mode: constants.MODE.CANCEL, modalVisibility: true }))
        } else {
          setExerciseState((prevState) => ({ ...prevState, mode: constants.MODE.PAUSE_CANCEL }))
        }
        break
      }
    }
  }

  const addRecipients = async () => {
    let mode = constants.MODE.DEFAULT

    try {
      setExerciseState((prevState) => ({ ...prevState, loading: true, modalVisibility: false }))
      // Normalize all recipients emails in a sigle array
      const recipientsEmails = recipients.reduce((result, recipient) => {
        if (recipient.username && recipient.username !== '') {
          result.push(`${recipient.username.trim()}@${representative.domain}`)
        }
        if (recipient.email) {
          result.push(recipient.email)
        }

        return result
      }, [])

      // If there is duplicate emails create form error
      if ( new Set(recipientsEmails).size !== recipientsEmails.length) {
        setExerciseState((prevState) => ({ ...prevState, loading: false }))
        setFormErrorMessage(intl.formatMessage({ id: 'phishing_tool_form_error_duplicate_values' } ))
        setFormError(true)

        return
      }

      await axios.post(
        `${process.env.REACT_APP_API_URL}${endpoint}/recipients`,
        { emails: recipientsToAdd },
        {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'x-kynd-phish-sim-code': representative.code,
            'x-kynd-phish-sim-email': representative.email
          }
        }
      )

      if (status !== constants.STATUS.STARTED) {
        await setStatus()
        mode = constants.MODE.STARTED
      }

      setExerciseState((prevState) => ({ ...prevState, loading: false, mode, recipients: prevState.recipients.map((item) => !item.username ? item : { email: `${item.username}@${representative.domain}` }) }))
    } catch (error) {
      setFormErrorMessage(intl.formatMessage({
        id: 'phishing_tool_form_error'
      }))
      setFormError(true)
      setExerciseState((prevState) => ({ ...prevState, loading: false }))
    }
  }


  const setStatus = async (value = constants.STATUS.STARTED) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}${endpoint}/status`,
        { value },
        {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'x-kynd-phish-sim-code': representative.code,
            'x-kynd-phish-sim-email': representative.email
          }
        }
      )

      setExerciseState((prevState) => ({ ...prevState, status: value }))
    } catch (error) {
      setFormErrorMessage(intl.formatMessage({
        id: 'phishing_tool_form_error'
      }))
      setFormError(true)
    }
  }

  const onModalMainAction = async () => {
    switch (mode) {
      case constants.MODE.PAUSE:
        setExerciseState((prevState) => ({ ...prevState, loading: true, modalVisibility: false }))
        await setStatus(constants.STATUS.PAUSED)
        setExerciseState((prevState) => ({ ...prevState, loading: false, mode: constants.MODE.DEFAULT }))
        break
      case constants.MODE.CANCEL:
        setExerciseState((prevState) => ({ ...prevState, loading: true, modalVisibility: false }))
        await setStatus(constants.STATUS.CANCELLED)
        setExerciseState((prevState) => ({ ...prevState, loading: false, mode: constants.MODE.DEFAULT }))
        break
      case constants.MODE.RESUME:
        setExerciseState((prevState) => ({ ...prevState, loading: true, modalVisibility: false }))
        await setStatus(constants.STATUS.STARTED)
        setExerciseState((prevState) => ({ ...prevState, loading: false, mode: constants.MODE.DEFAULT }))
        break
      default: {
        addRecipients()
        break
      }
    }
  }

  const onModalSecondaryAction = () => {
    switch (mode) {
      case constants.MODE.CANCEL: {
        if (status === constants.STATUS.PAUSED) {
          setExerciseState((prevState) => ({ ...prevState, mode: constants.MODE.DEFAULT, modalVisibility: false }))
        } else {
          setExerciseState((prevState) => ({ ...prevState, mode: constants.MODE.PAUSE_CANCEL, modalVisibility: false }))
        }
        break
      }
      case constants.MODE.PAUSE: {
        setExerciseState((prevState) => ({ ...prevState, mode: constants.MODE.PAUSE_CANCEL, modalVisibility: false }))
        break
      }
      case constants.MODE.RESUME: {
        setExerciseState((prevState) => ({ ...prevState, mode: constants.MODE.DEFAULT, modalVisibility: false }))
        break
      }
      default: {
        toggleModalVisibility()
        break
      }
    }
  }

  return (
    <>
      <Components.KyndModal
        open={modalVisibility}
        onClose={onModalSecondaryAction}
        title={intl.formatMessage({
          id: `phishing_tool_modal_title_${status.toLowerCase()}_${mode.toLowerCase()}`
        })}
        content={
          <ModalContent>
            {intl.formatMessage({ id: `phishing_tool_modal_text_${status.toLowerCase()}_${mode.toLowerCase()}` },
              { emailNum: recipientsToAdd.length })}
          </ModalContent>
        }
        footerContent={
          <ModalButtonsContainer>
            <Components.RegularButton onClick={onModalSecondaryAction}>
              {intl.formatMessage({ id: 'phishing_tool_modal_secondary_button' })}
            </Components.RegularButton>
            <Components.RegularButton secondary onClick={onModalMainAction}>
              {intl.formatMessage({ id: `phishing_tool_modal_primary_button_${status.toLowerCase()}_${mode.toLowerCase()}` })}
            </Components.RegularButton>
          </ModalButtonsContainer>
        }
      />
      <Components.FormContainer>
        <StyledForm
          onSubmit={onMainAction}
          loading={loading}
          error={formError}
        >
          <div className="submit-section-balancer">
            {
              mode === constants.MODE.PAUSE || (status === constants.STATUS.STARTED && mode === constants.MODE.CANCEL) || mode === constants.MODE.PAUSE_CANCEL
                ? (
                  <>
                    <BackLink onClick={onBackToExercise}>
                      {intl.formatMessage({ id: 'phishing_tool_back_exercise_summary' })}
                    </BackLink>
                  </>
                )
                : null
            }
          </div>
          <div className="fields-section">
            <div>
              <Components.LogoContainer>
                <Components.BrandedLogo theme={clientTheme} />
              </Components.LogoContainer>
              <InviteMessage>
                {intl.formatMessage({ id: `phishing_tool_header_text_${status.toLowerCase()}` }, { orgName })}
              </InviteMessage>
            </div>
            <EmailsContainer>
              {
                recipients.map((item, index) => (
                  <EmailInput
                    key={`email${index + 1}`}
                    item={item}
                    index={index}
                    setExerciseState={setExerciseState}
                    domain={domain}
                    mode={mode}
                    status={status}
                  />
                ))
              }
            </EmailsContainer>

            <FieldWrapper>
              <Message
                error
                content={formErrorMessage}
              />
            </FieldWrapper>
          </div>

          <div className="submit-section">
            <div className="submit-container-inner">

              <SubmitContainer>
                {!!intl.messages[`phishing_tool_secondary_button_${status.toLowerCase()}_${mode.toLowerCase()}`] &&
                  <SubmitButton
                    type="button"
                    onClick={onSecondaryAction}
                  >
                    {intl.formatMessage({ id: `phishing_tool_secondary_button_${status.toLowerCase()}_${mode.toLowerCase()}` })}
                  </SubmitButton>
                }
              </SubmitContainer>
              <SubmitContainer>
                <SubmitButton
                  type="submit"
                  secondary
                  disabled={disabled}
                >
                  {intl.formatMessage({ id: `phishing_tool_primary_button_${status.toLowerCase()}_${mode.toLowerCase()}` })}
                </SubmitButton>
              </SubmitContainer>
            </div>
          </div>
        </StyledForm>
      </Components.FormContainer>
    </>
  )
}

export default FormStep2
